import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntCopyContentComponent} from "./int-copy-content.component";

@NgModule({
  imports: [CommonModule],
  declarations: [IntCopyContentComponent],
  exports: [IntCopyContentComponent]
})
export class IntCopyContentModule {}
